import { useRef } from "react";
import { useIntersection } from "../../hooks/useIntersection";
import AnimSectionTemplate from "./AnimSectionTemplate";

export default function AnimSection({ children, className = "", delay = 0 }) {
  const ref = useRef();
  const visible = useIntersection(ref, { threshold: 0.1 });

  return (
    <AnimSectionTemplate ref={ref} visible={visible} delay={delay} className={className}>
      {children}
    </AnimSectionTemplate>
  );
}
